import React from 'react'
import {gql} from '@apollo/client'
import SelectField from '../SelectField'

const QUERY = gql`
  query GetPlansForPlanField {
    plans {
      collection {
        id
        name
      }
    }
  }
`

export default ({buttonText, onChange, errors, ...props}) => (
  <SelectField
    {...props}
    id='payment-detail-select'
    buttonText={buttonText || 'Select plan'}
    errors={errors}
    onChange={onChange}
    dataQuery={QUERY}
    dataField='plans'
  />
)
